// ============================================
// MOCK DATA FOR REKANKU PLATFORM
// ============================================

// ---------- PLANS ----------
export const plans = [
  {
    id: 1,
    name: 'Starter',
    slug: 'starter',
    price_monthly: 99000,
    price_yearly: 950400,
    trial_days: 14,
    is_popular: false,
    is_active: true,
    features: ['1 AI Agent', '1 WA Session', '10K token/bulan', 'Knowledge Base 100MB', 'Email Support'],
    limits: { max_agents: 1, max_wa_sessions: 1, max_token_per_month: 10000, kb_storage_mb: 100 },
    feature_flags: { ai_agent: true, whatsapp: true, analytics: false, white_label: false, integrations: false },
  },
  {
    id: 2,
    name: 'Pro',
    slug: 'pro',
    price_monthly: 299000,
    price_yearly: 2870400,
    trial_days: 14,
    is_popular: true,
    is_active: true,
    features: ['5 AI Agent', '3 WA Session', '50K token/bulan', 'Knowledge Base 500MB', 'Analytics Dashboard', 'Google Sheets Integration', 'Priority Support'],
    limits: { max_agents: 5, max_wa_sessions: 3, max_token_per_month: 50000, kb_storage_mb: 500 },
    feature_flags: { ai_agent: true, whatsapp: true, analytics: true, white_label: false, integrations: true },
  },
  {
    id: 3,
    name: 'Business',
    slug: 'business',
    price_monthly: 599000,
    price_yearly: 5750400,
    trial_days: 14,
    is_popular: false,
    is_active: true,
    features: ['Unlimited AI Agent', '10 WA Session', '200K token/bulan', 'Knowledge Base 2GB', 'Advanced Analytics', 'White Label', 'Custom Integration', 'Dedicated Support'],
    limits: { max_agents: -1, max_wa_sessions: 10, max_token_per_month: 200000, kb_storage_mb: 2048 },
    feature_flags: { ai_agent: true, whatsapp: true, analytics: true, white_label: true, integrations: true },
  },
];

// ---------- TENANT MOCK ----------
export const currentTenant = {
  id: 't-001',
  name: 'Toko Budi Pratama',
  slug: 'toko-budi-pratama',
  business_type: 'retail',
  owner_name: 'Budi Santoso',
  email: 'budi@tokobudi.com',
  phone: '+62 812-3456-7890',
  plan: 'pro',
  plan_name: 'Pro',
  status: 'active',
  subscription_end: '2025-02-15',
  days_remaining: 30,
};

export const tenantAnalytics = {
  conversations: { today: 247, this_week: 1523, trend_percent: 12.4 },
  agents: { total: 3, active: 2 },
  pending_approvals: 3,
  subscription: { plan: 'Pro', status: 'active', days_remaining: 30 },
  token_usage: { used: 18450, total: 50000, percent: 36.9 },
  response_time: { avg_seconds: 1.24, trend: -0.3 },
  new_customers: { this_week: 8, trend_percent: 15.2 },
  chart_7days: [
    { day: 'Sen', conversations: 180 },
    { day: 'Sel', conversations: 220 },
    { day: 'Rab', conversations: 195 },
    { day: 'Kam', conversations: 310 },
    { day: 'Jum', conversations: 280 },
    { day: 'Sab', conversations: 247 },
    { day: 'Min', conversations: 191 },
  ],
};

// ---------- AI AGENTS ----------
export const agents = [
  {
    id: 'ag-001',
    name: 'Asisten Toko Budi',
    description: 'AI assistant untuk layanan pelanggan Toko Budi',
    ai_provider: 'OpenAI',
    ai_model: 'gpt-4o',
    status: 'active',
    system_prompt: 'Kamu adalah asisten toko Budi yang ramah...',
    temperature: 0.7,
    max_tokens: 500,
    token_today: 1247,
    token_limit: 10000,
    rules_count: 3,
    tools_count: 5,
    channels_count: 2,
    channels: [
      { type: 'whatsapp', number: '+62 812-3456-7890', status: 'connected', priority: 1 },
      { type: 'telegram', username: '@TokoBudiBot', status: 'connected', priority: 2 },
    ],
    rules: [
      { id: 'r1', condition: 'Jika tanya stok', action: 'call_tool(cek_stok)' },
      { id: 'r2', condition: 'Jika tanya harga', action: 'search_kb(query)' },
      { id: 'r3', condition: 'Jika mau order', action: 'call_tool(buat_pesanan)' },
    ],
    tools: [
      { id: 't1', name: 'cek_stok', display_name: 'Cek Stok Produk', requires_approval: false },
      { id: 't2', name: 'buat_pesanan', display_name: 'Buat Pesanan', requires_approval: true },
      { id: 't3', name: 'cek_ongkir', display_name: 'Cek Ongkos Kirim', requires_approval: false },
      { id: 't4', name: 'track_order', display_name: 'Lacak Pesanan', requires_approval: false },
      { id: 't5', name: 'get_customer_info', display_name: 'Info Pelanggan', requires_approval: false },
    ],
    usage_logs: [
      { date: '2025-01-15', tokens: 1247, requests: 89 },
      { date: '2025-01-14', tokens: 1089, requests: 76 },
      { date: '2025-01-13', tokens: 1456, requests: 102 },
      { date: '2025-01-12', tokens: 934, requests: 65 },
      { date: '2025-01-11', tokens: 1123, requests: 78 },
    ],
  },
  {
    id: 'ag-002',
    name: 'Budi Info Bot',
    description: 'Bot informasi produk dan promosi',
    ai_provider: 'OpenAI',
    ai_model: 'gpt-4o-mini',
    status: 'active',
    system_prompt: 'Jawab pertanyaan tentang produk dan promosi...',
    temperature: 0.5,
    max_tokens: 300,
    token_today: 856,
    token_limit: 5000,
    rules_count: 2,
    tools_count: 3,
    channels_count: 1,
    channels: [
      { type: 'whatsapp', number: '+62 812-3456-7890', status: 'connected', priority: 1 },
    ],
    rules: [],
    tools: [],
    usage_logs: [],
  },
  {
    id: 'ag-003',
    name: 'Survey Bot',
    description: 'Bot untuk survei kepuasan pelanggan',
    ai_provider: 'Anthropic',
    ai_model: 'claude-3-haiku',
    status: 'standby',
    system_prompt: 'Lakukan survei kepuasan pelanggan...',
    temperature: 0.3,
    max_tokens: 200,
    token_today: 0,
    token_limit: 3000,
    rules_count: 1,
    tools_count: 1,
    channels_count: 0,
    channels: [],
    rules: [],
    tools: [],
    usage_logs: [],
  },
];

// ---------- WA SESSIONS ----------
export const waSessions = [
  {
    id: 'wa-001',
    phone: '+62 812-3456-7890',
    status: 'connected',
    session_duration: '3 jam 42 menit',
    messages_today: 84,
    last_activity: '2025-01-15T14:30:00',
  },
  {
    id: 'wa-002',
    phone: '+62 813-9876-5432',
    status: 'connected',
    session_duration: '1 jam 15 menit',
    messages_today: 23,
    last_activity: '2025-01-15T13:45:00',
  },
  {
    id: 'wa-003',
    phone: '+62 814-5555-0000',
    status: 'disconnected',
    session_duration: '-',
    messages_today: 0,
    last_activity: '2025-01-14T18:00:00',
  },
];

// ---------- CUSTOMERS ----------
export const customers = [
  { id: 'c1', name: 'Ahmad Santoso', phone: '+62812345678', email: 'ahmad@gmail.com', role: 'VIP', last_contact: '2025-01-15', total_orders: 24, total_spent: 4800000 },
  { id: 'c2', name: 'Budi Pratama', phone: '+62813456789', email: 'budi.p@gmail.com', role: 'Regular', last_contact: '2025-01-10', total_orders: 8, total_spent: 1200000 },
  { id: 'c3', name: 'Citra Sari', phone: '+62814567890', email: 'citra.s@gmail.com', role: 'Regular', last_contact: '2025-01-12', total_orders: 12, total_spent: 2400000 },
  { id: 'c4', name: 'Dewi Lestari', phone: '+62815678901', email: 'dewi.l@gmail.com', role: 'VIP', last_contact: '2025-01-14', total_orders: 35, total_spent: 8900000 },
  { id: 'c5', name: 'Eko Prasetyo', phone: '+62816789012', email: 'eko.p@gmail.com', role: 'Regular', last_contact: '2025-01-08', total_orders: 3, total_spent: 450000 },
  { id: 'c6', name: 'Fitri Handayani', phone: '+62817890123', email: 'fitri.h@gmail.com', role: 'New', last_contact: '2025-01-15', total_orders: 0, total_spent: 0 },
  { id: 'c7', name: 'Gunawan Wijaya', phone: '+62818901234', email: 'gunawan.w@gmail.com', role: 'Regular', last_contact: '2025-01-11', total_orders: 6, total_spent: 900000 },
];

// ---------- KNOWLEDGE BASE ----------
export const knowledgeBases = [
  {
    id: 'kb-001',
    name: 'Katalog Produk 2025',
    document_count: 12,
    chunks_count: 4521,
    size_mb: 24.5,
    status: 'ready',
    used_by: ['Asisten Toko Budi'],
    documents: [
      { id: 'd1', name: 'Katalog_Jan2025.pdf', size_mb: 2, status: 'ready' },
      { id: 'd2', name: 'FAQ_Pelanggan.txt', size_mb: 0.05, status: 'processing' },
      { id: 'd3', name: 'Daftar_Harga_2025.xlsx', size_mb: 1.2, status: 'ready' },
      { id: 'd4', name: 'Kebijakan_Pengembalian.pdf', size_mb: 0.5, status: 'ready' },
    ],
  },
  {
    id: 'kb-002',
    name: 'Resep & Menu',
    document_count: 8,
    chunks_count: 2100,
    size_mb: 15.2,
    status: 'ready',
    used_by: [],
    documents: [
      { id: 'd5', name: 'Menu_Utama.pdf', size_mb: 3, status: 'ready' },
      { id: 'd6', name: 'Resep_Rahasia.pdf', size_mb: 1.5, status: 'failed' },
    ],
  },
];

// ---------- CONVERSATIONS ----------
export const conversations = [
  {
    id: 'conv-001',
    customer: { name: 'Ahmad Santoso', phone: '+62812345678', avatar: 'AS' },
    last_message: 'Minta cek stok sepatu ukuran 40',
    time: '14:30',
    unread: 1,
    status: 'active',
    agent: 'Asisten Toko Budi',
    channel: 'whatsapp',
    messages: [
      { id: 'm1', sender: 'customer', text: 'Halo, stok sepatu ukuran 40 masih ada?', time: '14:30' },
      { id: 'm2', sender: 'ai', text: 'Halo Kak Ahmad! Untuk sepatu ukuran 40, saat ini masih tersedia 12 pasang ya. Mau diorder sekarang? 😊', time: '14:30' },
      { id: 'm3', sender: 'ai', text: '[Tool Call: buat_pesanan]', time: '14:31', type: 'tool_call' },
      { id: 'm4', sender: 'system', text: 'Menunggu approval untuk buat_pesanan', time: '14:31', type: 'system' },
    ],
    ai_summary: 'Pelanggan ingin mengecek stok sepatu ukuran 40 dan tertarik untuk order.',
  },
  {
    id: 'conv-002',
    customer: { name: 'Budi Pratama', phone: '+62813456789', avatar: 'BP' },
    last_message: 'Ongkir ke Jakarta berapa ya?',
    time: '13:15',
    unread: 0,
    status: 'active',
    agent: 'Asisten Toko Budi',
    channel: 'telegram',
    messages: [
      { id: 'm5', sender: 'customer', text: 'Ongkir ke Jakarta berapa ya?', time: '13:15' },
      { id: 'm6', sender: 'ai', text: 'Untuk pengiriman ke Jakarta via JNE REG, ongkirnya sekitar Rp 15.000-25.000 tergantung berat paket ya, Kak. Mau saya hitungkan untuk pesanan tertentu?', time: '13:15' },
    ],
    ai_summary: 'Pelanggan menanyakan ongkos kirim ke Jakarta.',
  },
  {
    id: 'conv-003',
    customer: { name: 'Citra Sari', phone: '+62814567890', avatar: 'CS' },
    last_message: 'Terima kasih infonya!',
    time: '12:00',
    unread: 0,
    status: 'closed',
    agent: 'Budi Info Bot',
    channel: 'whatsapp',
    messages: [
      { id: 'm7', sender: 'customer', text: 'Ada promo apa saja bulan ini?', time: '11:55' },
      { id: 'm8', sender: 'ai', text: 'Bulan ini ada promo diskon 20% untuk semua kaos! Yuk cek koleksinya 🎉', time: '11:55' },
      { id: 'm9', sender: 'customer', text: 'Terima kasih infonya!', time: '12:00' },
    ],
    ai_summary: 'Pelanggan menanyakan promo bulan ini dan sudah mendapatkan info.',
  },
];

// ---------- TOOL APPROVALS ----------
export const toolApprovals = [
  {
    id: 'ta-001',
    tool_name: 'buat_pesanan',
    agent: 'Asisten Toko Budi',
    customer: { name: 'Ahmad Santoso', phone: '+62812345678' },
    params: { product_id: 'prod-001', quantity: 2, customer_id: 'c1' },
    status: 'pending',
    created_at: '2 menit lalu',
  },
  {
    id: 'ta-002',
    tool_name: 'refund_pesanan',
    agent: 'Asisten Toko Budi',
    customer: { name: 'Dewi Lestari', phone: '+62815678901' },
    params: { order_id: 'ord-123', reason: 'ukuran salah' },
    status: 'pending',
    created_at: '15 menit lalu',
  },
  {
    id: 'ta-003',
    tool_name: 'update_stok',
    agent: 'Budi Info Bot',
    customer: { name: 'System', phone: '-' },
    params: { product_id: 'prod-005', new_stock: 50 },
    status: 'pending',
    created_at: '1 jam lalu',
  },
];

// ---------- INTEGRATIONS ----------
export const integrations = {
  spreadsheets: [
    { id: 'sp-001', name: 'Data Pelanggan Toko', target: 'customers', sync_type: 'auto', last_sync: '15 Jan 2025, 06:00', status: 'connected' },
    { id: 'sp-002', name: 'Stok Produk', target: 'products', sync_type: 'manual', last_sync: '14 Jan 2025, 10:30', status: 'connected' },
  ],
  webhooks: [
    { id: 'wh-001', name: 'Webhook Notif Order', trigger: 'order.created', url: 'https://script.google.com/xxx', last_triggered: '15 Jan, 14:32', status_code: 200 },
    { id: 'wh-002', name: 'New Customer Alert', trigger: 'customer.created', url: 'https://script.google.com/yyy', last_triggered: '14 Jan, 09:15', status_code: 200 },
  ],
  schedules: [
    { id: 'sc-001', name: 'Export Data Harian', cron: '0 6 * * *', description: 'Setiap hari pukul 06:00', status: 'active' },
    { id: 'sc-002', name: 'Backup Knowledge Base', cron: '0 2 * * 0', description: 'Setiap Minggu pukul 02:00', status: 'active' },
  ],
};

// ---------- INVOICES ----------
export const invoices = [
  { id: 'INV-2025-0042', plan: 'Pro', period: 'Jan 2025', amount: 299000, status: 'paid', date: '2025-01-01' },
  { id: 'INV-2025-0041', plan: 'Pro', period: 'Des 2024', amount: 299000, status: 'paid', date: '2024-12-01' },
  { id: 'INV-2025-0040', plan: 'Starter', period: 'Nov 2024', amount: 99000, status: 'paid', date: '2024-11-01' },
];

// ---------- TEAM MEMBERS ----------
export const teamMembers = [
  { id: 'tm-1', name: 'Budi Santoso', email: 'budi@tokobudi.com', role: 'Owner', permissions: ['all'], status: 'active', joined: '2024-06-15' },
  { id: 'tm-2', name: 'Sari Dewi', email: 'sari@tokobudi.com', role: 'Admin', permissions: ['agent.manage', 'customer.view', 'conversation.view'], status: 'active', joined: '2024-08-20' },
  { id: 'tm-3', name: 'Riko Pratama', email: 'riko@tokobudi.com', role: 'Staff', permissions: ['conversation.view', 'customer.view'], status: 'active', joined: '2024-10-01' },
  { id: 'tm-4', name: 'Ani Wijaya', email: 'ani@tokobudi.com', role: 'Staff', permissions: ['conversation.view'], status: 'invited', joined: null },
];

// ---------- AFFILIATE DATA ----------
export const affiliateData = {
  code: 'SIPOD2025',
  referral_link: 'https://rekanku.id/r/SIPOD2025',
  stats: {
    total_referrals: 24,
    active_referrals: 18,
    total_commission_earned: 4850000,
    pending_commission: 450000,
    available_balance: 1250000,
  },
};

export const referrals = [
  { id: 'ref-1', name: 'Toko Ahmad Santoso', email: 'ahmad@gmail.com', registered: '15 Jan 2025', status: 'active', commission: 300000 },
  { id: 'ref-2', name: 'Bengkel Pak Joko', email: 'joko@gmail.com', registered: '10 Jan 2025', status: 'active', commission: 300000 },
  { id: 'ref-3', name: 'Warung Bu Sari', email: 'sari@gmail.com', registered: '08 Jan 2025', status: 'trial', commission: 0 },
  { id: 'ref-4', name: 'Apotek Sehat', email: 'sehat@gmail.com', registered: '05 Jan 2025', status: 'active', commission: 300000 },
  { id: 'ref-5', name: 'Bakso Pak Amin', email: 'amin@gmail.com', registered: '01 Jan 2025', status: 'expired', commission: 150000 },
  { id: 'ref-6', name: 'Toko Elektronik Jaya', email: 'jaya@gmail.com', registered: '28 Des 2024', status: 'active', commission: 300000 },
];

export const commissions = [
  { id: 'com-1', referral: 'Toko Ahmad Santoso', amount: 300000, status: 'paid', date: '15 Jan 2025', invoice: 'INV-2025-0042' },
  { id: 'com-2', referral: 'Bengkel Pak Joko', amount: 300000, status: 'approved', date: '14 Jan 2025', invoice: 'INV-2025-0038' },
  { id: 'com-3', referral: 'Warung Bu Sari', amount: 0, status: 'pending', date: '08 Jan 2025', invoice: '-' },
  { id: 'com-4', referral: 'Apotek Sehat', amount: 300000, status: 'paid', date: '05 Jan 2025', invoice: 'INV-2025-0035' },
  { id: 'com-5', referral: 'Bakso Pak Amin', amount: 150000, status: 'rejected', date: '01 Jan 2025', invoice: '-', reason: 'Tenant expired sebelum pembayaran' },
];

export const withdrawals = [
  { id: 'wd-1', amount: 1500000, method: 'bank_transfer', bank: 'BCA', account: '1234567890', holder: 'Sipod Official', status: 'paid', date: '01 Jan 2025' },
  { id: 'wd-2', amount: 500000, method: 'bank_transfer', bank: 'BCA', account: '1234567890', holder: 'Sipod Official', status: 'approved', date: '15 Jan 2025' },
  { id: 'wd-3', amount: 1250000, method: 'bank_transfer', bank: 'BCA', account: '1234567890', holder: 'Sipod Official', status: 'pending', date: '15 Jan 2025' },
];

// ---------- SUPERADMIN DATA ----------
export const adminDashboard = {
  mrr: 45200000,
  arr: 542400000,
  mrr_growth_percent: 8.3,
  total_tenants: 234,
  active_tenants: 198,
  trial_tenants: 24,
  churn_rate_percent: 2.1,
  total_users: 1847,
  new_users_today: 12,
  active_wa_sessions: 87,
  wa_nodes_online: 4,
  conversations_per_hour: 14231,
  mrr_chart: [
    { month: 'Agu', mrr: 22000000 },
    { month: 'Sep', mrr: 27000000 },
    { month: 'Okt', mrr: 31000000 },
    { month: 'Nov', mrr: 35000000 },
    { month: 'Des', mrr: 40000000 },
    { month: 'Jan', mrr: 45200000 },
  ],
  security_alerts: 3,
  suspect_ips: 3,
};

export const adminTenants = [
  { id: 101, name: 'Toko Budi Pratama', owner_email: 'budi@tokobudi.com', plan: 'Pro', status: 'active', business_type: 'Retail', members: 3, agents: 2, wa_sessions: 1, created: '2024-06-15' },
  { id: 102, name: 'Warung Sari', owner_email: 'sari@warungsari.com', plan: 'Starter', status: 'trial', business_type: 'FnB', members: 1, agents: 1, wa_sessions: 0, created: '2025-01-08' },
  { id: 103, name: 'Apotek Sehat', owner_email: 'sehat@apoteksehat.com', plan: 'Pro', status: 'suspended', business_type: 'Retail', members: 2, agents: 1, wa_sessions: 1, created: '2024-09-20' },
  { id: 104, name: 'Bengkel Joko', owner_email: 'joko@bengkeljoko.com', plan: 'Starter', status: 'active', business_type: 'Rental', members: 1, agents: 1, wa_sessions: 1, created: '2024-10-05' },
  { id: 105, name: 'Toko Elektronik Jaya', owner_email: 'jaya@elektrojaya.com', plan: 'Business', status: 'active', business_type: 'Retail', members: 5, agents: 4, wa_sessions: 2, created: '2024-07-01' },
  { id: 106, name: 'Salon Cantik', owner_email: 'cantik@salon.com', plan: 'Starter', status: 'expired', business_type: 'Retail', members: 1, agents: 1, wa_sessions: 0, created: '2024-11-15' },
];

export const adminUsers = [
  { id: 1, name: 'Admin Rekanku', email: 'admin@rekanku.id', roles: ['superadmin'], status: 'active', last_login: '2025-01-15 14:30', tenants: [] },
  { id: 2, name: 'Budi Santoso', email: 'budi@tokobudi.com', roles: ['tenant_member'], status: 'active', last_login: '2025-01-15 13:00', tenants: ['Toko Budi Pratama'] },
  { id: 3, name: 'Sipod Official', email: 'sipod@gmail.com', roles: ['affiliate'], status: 'active', last_login: '2025-01-15 10:00', tenants: [] },
  { id: 4, name: 'Sari Dewi', email: 'sari@warungsari.com', roles: ['tenant_member'], status: 'active', last_login: '2025-01-14 16:00', tenants: ['Warung Sari'] },
  { id: 5, name: 'Spam Bot', email: 'spam@evil.com', roles: ['tenant_member'], status: 'inactive', last_login: '2025-01-01 00:00', tenants: [] },
];

export const adminSubscriptions = [
  { id: 1, tenant: 'Toko Budi Pratama', plan: 'Pro', status: 'active', start: '2024-07-01', end: '2025-02-15', amount: 299000 },
  { id: 2, tenant: 'Warung Sari', plan: 'Starter', status: 'trial', start: '2025-01-08', end: '2025-01-22', amount: 0 },
  { id: 3, tenant: 'Apotek Sehat', plan: 'Pro', status: 'suspended', start: '2024-09-20', end: '2025-01-20', amount: 299000 },
  { id: 4, tenant: 'Bengkel Joko', plan: 'Starter', status: 'active', start: '2024-10-05', end: '2025-02-05', amount: 99000 },
  { id: 5, tenant: 'Toko Elektronik Jaya', plan: 'Business', status: 'active', start: '2024-07-01', end: '2025-02-01', amount: 599000 },
];

export const adminPromos = [
  { id: 1, code: 'LEBARAN2025', discount_type: 'percent', discount_value: 30, max_uses: 100, used_count: 23, valid_from: '2025-03-20', valid_until: '2025-04-15', applicable_plans: ['pro', 'business'], is_active: true },
  { id: 2, code: 'LAUNCH2024', discount_type: 'fixed', discount_value: 50000, max_uses: 500, used_count: 312, valid_from: '2024-06-01', valid_until: '2025-06-01', applicable_plans: ['starter', 'pro', 'business'], is_active: true },
  { id: 3, code: 'EXPIRED10', discount_type: 'percent', discount_value: 10, max_uses: 50, used_count: 50, valid_from: '2024-01-01', valid_until: '2024-06-30', applicable_plans: ['pro'], is_active: false },
];

export const adminAffiliateWithdrawals = [
  { id: 'aw-1', affiliate_name: 'Sipod Official', affiliate_email: 'sipod@gmail.com', amount: 1250000, bank: 'BCA', account: '1234567890', status: 'pending', date: '15 Jan 2025' },
  { id: 'aw-2', affiliate_name: 'Mitra Jaya', affiliate_email: 'mitra@gmail.com', amount: 500000, bank: 'Mandiri', account: '0987654321', status: 'approved', date: '14 Jan 2025' },
  { id: 'aw-3', affiliate_name: 'Partner Pro', affiliate_email: 'partner@gmail.com', amount: 2000000, bank: 'BNI', account: '1122334455', status: 'paid', date: '10 Jan 2025' },
];

export const waNodes = [
  { id: 'node-sg-01', name: 'SG Node 01', location: 'Singapore', status: 'online', sessions: 24, max_sessions: 50, cpu: 34, memory: 30, uptime: '14 hari', last_heartbeat: '2 menit lalu' },
  { id: 'node-sg-02', name: 'SG Node 02', location: 'Singapore', status: 'degraded', sessions: 45, max_sessions: 50, cpu: 82, memory: 85, uptime: '7 hari', last_heartbeat: '1 menit lalu' },
  { id: 'node-id-01', name: 'ID Node 01', location: 'Jakarta', status: 'online', sessions: 12, max_sessions: 100, cpu: 15, memory: 20, uptime: '30 hari', last_heartbeat: '30 detik lalu' },
  { id: 'node-id-02', name: 'ID Node 02', location: 'Jakarta', status: 'online', sessions: 6, max_sessions: 100, cpu: 8, memory: 12, uptime: '30 hari', last_heartbeat: '45 detik lalu' },
  { id: 'node-id-03', name: 'ID Node 03', location: 'Surabaya', status: 'offline', sessions: 0, max_sessions: 50, cpu: 0, memory: 0, uptime: '-', last_heartbeat: '2 jam lalu' },
];

export const aiProviders = [
  { id: 'ap-1', name: 'OpenAI', slug: 'openai', base_url: 'https://api.openai.com/v1', api_key_masked: 'sk-proj-●●●●●●●●', is_active: true, default_model: 'gpt-4o', models: [
    { name: 'GPT-4o', slug: 'gpt-4o', context_window: 128000, input_price: 5, output_price: 15, supports_fc: true, is_active: true },
    { name: 'GPT-4o-mini', slug: 'gpt-4o-mini', context_window: 128000, input_price: 0.15, output_price: 0.6, supports_fc: true, is_active: true },
  ]},
  { id: 'ap-2', name: 'Anthropic', slug: 'anthropic', base_url: 'https://api.anthropic.com/v1', api_key_masked: 'sk-ant-●●●●●●●●', is_active: true, default_model: 'claude-3-haiku', models: [
    { name: 'Claude 3.5 Sonnet', slug: 'claude-3-5-sonnet', context_window: 200000, input_price: 3, output_price: 15, supports_fc: true, is_active: true },
    { name: 'Claude 3 Haiku', slug: 'claude-3-haiku', context_window: 200000, input_price: 0.25, output_price: 1.25, supports_fc: true, is_active: true },
  ]},
];

export const toolRegistry = [
  { id: 'tr-1', name: 'cek_stok', display_name: 'Cek Stok Produk', category: 'retail', requires_approval: false, is_active: true, used_by: 5 },
  { id: 'tr-2', name: 'buat_pesanan', display_name: 'Buat Pesanan', category: 'retail', requires_approval: true, is_active: true, used_by: 3 },
  { id: 'tr-3', name: 'cek_ongkir', display_name: 'Cek Ongkos Kirim', category: 'retail', requires_approval: false, is_active: true, used_by: 4 },
  { id: 'tr-4', name: 'buat_reservasi', display_name: 'Buat Reservasi', category: 'fnb', requires_approval: false, is_active: true, used_by: 2 },
  { id: 'tr-5', name: 'cek_ketersediaan_item', display_name: 'Cek Ketersediaan Item', category: 'rental', requires_approval: false, is_active: true, used_by: 1 },
];

export const auditLogs = [
  { id: 'al-1', severity: 'critical', category: 'tenant', event: 'tenant.delete', user: 'admin@rekanku.id', target: 'Tenant #103 Bakso Pak Amin', changes: '{ "status": "active" → "deleted" }', timestamp: '2025-01-15 14:32:01' },
  { id: 'al-2', severity: 'warning', category: 'subscription', event: 'subscription.cancel', user: 'budi@tokobudi.com', target: 'Subscription #2', changes: '{ "status": "active" → "cancelled" }', timestamp: '2025-01-15 13:20:00' },
  { id: 'al-3', severity: 'info', category: 'auth', event: 'auth.login', user: 'admin@rekanku.id', target: 'IP: 103.0.113.42', changes: '-', timestamp: '2025-01-15 14:30:00' },
  { id: 'al-4', severity: 'success', category: 'subscription', event: 'payment.success', user: 'system', target: 'Invoice INV-2025-0042', changes: 'Rp 299.000', timestamp: '2025-01-15 12:00:00' },
  { id: 'al-5', severity: 'warning', category: 'security', event: 'auth.failed_login', user: 'unknown', target: 'IP: 203.0.113.42', changes: '15x attempts', timestamp: '2025-01-15 14:00:00' },
  { id: 'al-6', severity: 'info', category: 'agent', event: 'agent.create', user: 'budi@tokobudi.com', target: 'Agent "Survey Bot"', changes: '-', timestamp: '2025-01-14 16:00:00' },
  { id: 'al-7', severity: 'critical', category: 'security', event: 'security.rate_limit', user: 'system', target: 'IP: 198.51.100.0', changes: 'Rate limit triggered', timestamp: '2025-01-15 09:30:00' },
];

export const securityDashboard = {
  failed_logins_24h: 47,
  rate_limits_today: 12,
  suspect_ips: 3,
  anomalies: 2,
  failed_login_chart: [
    { hour: '00', count: 2 }, { hour: '01', count: 0 }, { hour: '02', count: 1 },
    { hour: '03', count: 0 }, { hour: '04', count: 0 }, { hour: '05', count: 0 },
    { hour: '06', count: 1 }, { hour: '07', count: 3 }, { hour: '08', count: 5 },
    { hour: '09', count: 4 }, { hour: '10', count: 8 }, { hour: '11', count: 6 },
    { hour: '12', count: 3 }, { hour: '13', count: 2 }, { hour: '14', count: 12 },
  ],
  suspect_ip_list: [
    { ip: '203.0.113.42', location: 'ID', failed_count: 15, last_seen: '14:30', status: 'active' },
    { ip: '198.51.100.0', location: 'CN', failed_count: 8, last_seen: '09:30', status: 'active' },
    { ip: '192.0.2.1', location: 'RU', failed_count: 5, last_seen: '11:00', status: 'active' },
  ],
  anomaly_events: [
    { severity: 'high', description: 'admin@rekanku.id — Hapus 15 tenant dalam 5 menit', time: '2025-01-15 14:30' },
    { severity: 'medium', description: 'User spam@evil.com — Login dari 5 IP berbeda dalam 1 jam', time: '2025-01-15 10:00' },
  ],
};

export const systemSettings = {
  general: {
    app_name: 'Rekanku',
    tagline: 'Rekan AI-mu untuk Bisnis yang Lebih Cerdas',
    app_url: 'https://rekanku.id',
    support_email: 'support@rekanku.id',
  },
  payment: {
    midtrans_env: 'production',
    midtrans_client_key: 'Mid-client-●●●●●●●●',
    midtrans_server_key: 'Mid-server-●●●●●●●●',
    midtrans_connected: true,
  },
  features: {
    affiliate_enabled: true,
    trial_days: 14,
    maintenance_mode: false,
    commission_rate: 16.7,
    min_withdrawal: 100000,
  },
  health: {
    database: 'healthy',
    redis: 'healthy',
    queue_workers: 3,
    storage: 'healthy',
    midtrans: 'healthy',
  },
};

// ---------- BUSINESS MODULES ----------
export const retailProducts = [
  { id: 'p1', name: 'Sepatu Sport Pro', price: 250000, stock: 12, category: 'Sepatu', image: '/placeholder-product.jpg', status: 'active' },
  { id: 'p2', name: 'Kaos Premium Cotton', price: 85000, stock: 45, category: 'Pakaian', image: '/placeholder-product.jpg', status: 'active' },
  { id: 'p3', name: 'Celana Jeans Slim', price: 180000, stock: 28, category: 'Pakaian', image: '/placeholder-product.jpg', status: 'active' },
  { id: 'p4', name: 'Tas Ransel Outdoor', price: 320000, stock: 3, category: 'Aksesoris', image: '/placeholder-product.jpg', status: 'low_stock' },
  { id: 'p5', name: 'Topi Baseball', price: 65000, stock: 0, category: 'Aksesoris', image: '/placeholder-product.jpg', status: 'out_of_stock' },
  { id: 'p6', name: 'Jaket Hoodie', price: 195000, stock: 20, category: 'Pakaian', image: '/placeholder-product.jpg', status: 'active' },
];

// ---------- HELPER ----------
export function formatRupiah(amount: number): string {
  return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(amount);
}

export function formatNumber(num: number): string {
  return new Intl.NumberFormat('id-ID').format(num);
}
